// extracted by mini-css-extract-plugin
export var active = "Header-module--active--b8060";
export var backgroundRectangle = "Header-module--backgroundRectangle--8bd02";
export var button = "Header-module--button--6def7";
export var contactContainer = "Header-module--contactContainer--2e645";
export var container = "Header-module--container--ac1eb";
export var decor = "Header-module--decor--aab60";
export var expanded = "Header-module--expanded--eb7df";
export var expandedContent = "Header-module--expandedContent--5eaad";
export var gomesLogo = "Header-module--gomesLogo--fdaa5";
export var hamburger = "Header-module--hamburger--2e478";
export var hamburgerBox = "Header-module--hamburger-box--003ae";
export var hamburgerInner = "Header-module--hamburger-inner--87e1d";
export var hamburgerSqueeze = "Header-module--hamburger--squeeze--34b94";
export var headerContent = "Header-module--headerContent--edcfd";
export var hidden = "Header-module--hidden--f2f8e";
export var image = "Header-module--image--87335";
export var imageContainer = "Header-module--imageContainer--666e9";
export var isActive = "Header-module--is-active--893f7";
export var lineAbove = "Header-module--lineAbove--56925";
export var logo = "Header-module--logo--113f0";
export var logoContainer = "Header-module--logoContainer--720b3";
export var logoLink = "Header-module--logoLink--39d4f";
export var menuList = "Header-module--menuList--17a2b";
export var mini = "Header-module--mini--09f08";
export var mobile = "Header-module--mobile--bd34a";
export var relativeWrapper = "Header-module--relativeWrapper--603c3";
export var residentLink = "Header-module--residentLink--b8607";
export var rightContainer = "Header-module--rightContainer--70650";
export var socials = "Header-module--socials--b5db9";
export var zoomedIn = "Header-module--zoomedIn--e3078";